<template>
  <section class="container story02">
    <div class="story02--con">
        <div class="story02--left col-sm-5 order-2 order-sm-1"></div>
        <div class="story02--right col-sm-7 order-1 order-sm-2">
          <p class="story02--text">
            사람의 몸은 커다란 우주를 닮았습니다.<br>
            천억 개의 별을 가진 은하처럼 우리의 몸에도 백조 개의 세포가 별처럼 반짝거리고 있으니까요.
          </p>
          <p class="story02--text">
            우주를 가득 채운 별과 우리 몸을 가득 채운 세포는 아무도 모르는 사이 태어나고 사라짐을 반복합니다.<br>
            지금 이 순간에도 보이지 않는 피부 깊은 곳에선 어리고 건강한 세포가 태어나 반짝반짝 빛나고 있죠.
          </p>
          <p class="story02--text">
          하지만 멀고 먼 우주의 끝에서 희미하게 빛나는 별들처럼 피부 깊은 곳에서 새롭게 탄생한 어린 세포들이 사그라지는 세포에 가려져 빛을 잃어간다면 어떨까요?  
          </p>
          <p class="story02--text">
            ‘인셀덤 프로젝트’는 수많은 연구와 노력의 결실로 어리고 건강한 세포 본연의 빛을 살려내는 비밀 찾기에 이르렀습니다.<br>
            이 기술을 바탕으로 인셀덤은 저 먼 우주에서 스스로 빛나는 별들처럼 세상에서 가장 아름다운 피부 본연의 빛을 위한 노력을 멈추지 않겠습니다.
          </p>
          <p class="story02--stit">어린 세포 발견의 비밀</p>
        </div>
      </div>
  </section>
</template>

<script>
import Section from './Section2.vue';
export default {
  components: { Section },
  name: 'Section2',
};
</script>

<style lang='scss' scoped>
.brs{
  display: block;
  @media (max-width: 950px) {
    display: none !important;
  }
}
</style>
